<template>
  <div>
    <div class="header">
      <div class="header_content">
        <div v-if="!hasToken" @click="toLogin('/Register')">{{$t("auth.register")}}</div>
        <div v-else></div>
        <div class="img">
          <img src="/img/homenavlogo.png" alt="" />
        </div>
        <div style="display: flex; align-items: center;" v-if="!hasToken" @click="toLogin('/Login')">
          <van-icon name="chat-o" color="#fff" size="24" />
          {{$t("auth.login")}}
        </div>
        <div v-else @click="toLogin('/ServiceOnline')">
          <van-icon name="chat-o" color="#fff" size="24" />
        </div>
      </div>
    </div>

    <div style="height: 160px;">
      <swiper class="banner_swiper" :options="bannerSwiperOption">
        <swiper-slide v-for="(v, key) in banners" :key="key">
          <van-image
            class="banner_img"
            :src="getBannerUrl(v.url)"
            width="100%"
            height="160px"
            fit="cover"
          >
            <template v-slot:loading>
              <van-loading type="circular" />
            </template>
          </van-image>
        </swiper-slide>
      </swiper>
    </div>

    <div style="padding: 8px; background: rgb(243, 243, 245);">
      <van-notice-bar
        class="notice-swiper"
        color="rgb(62, 30, 136)"
        background="#fff"
        scrollable
        :text="notice"
      >
        <template #left-icon>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAkCAYAAAD2IghRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC60lEQVRYhdXYXahUVRQH8N/dXft4CBLKS4QgPWReEx81UXtIoxAiKTJIMX0tjdCLkGZZBCqXKIIgEgtKCQIhiqLSlz6M9CEI4oaUglIvUSiIqNQ5Paw5cBzHO2fmnmnm/mGYs9dea+//2WfvtdZeQ2Prf5XkhvKs8Z9LMinPDcmlPJ6T7Iq+1NCP/queZ6U8G0t5tirJ85Rnh1KevdBavxizmLMsC53gUeaQG1Y/nsEruKUkG8W9WFHXJKmugbAY3+BNV5IucL+pEV+G24tGHcRvxhv4Hkvb6I52Mf5KHMXX+BkLmTrxtZjA5or6/3Qw9nx8hC/FNoOZ4kW63uNLsR0PdmiXVdC5DTu0XozDeJ/WxEdxD0aQN37/4ibMxhIs6pBwFQxjK7a5+oycwIv4sKxcYCHG1XjyO8B67MSdTfLzeBV7NX2tgvgKfNVrdtfAOLa0kL8lSP/RymhYeIXPe8erLR5van+MXfhxMqMkDkEvAlFVPIqf8AMexiPakCYIP9RTWu1xXMM3d4KE6+vn0nsk4eqmHZLw09MOdSZZ/yv66U3K2IgFFXUvYN8gEH8Wr3dos3EQtsqtXdiMDMKK7xFnrcjVJ8sgZ+Ac3h4E4udFitwRBmGrdIVpTfy6fpPoBgmX+k2iGySc6jOHO0QOfkiUOCoh4WCvGFXEeyIPXy1KHPsxp51Rwhf4pIfE2uFEU3uDKHm8hBuuZVR4lcdEFaofeBpj+Ksku1Hc6n/BU62MCuKXsVy85e+9YjgJxnEXXmuSz8G7+A4PlDuaI+cu7BYFn9nizYsQnIkXHcFcPKFeV/q3uO3vE6u9ptS3RGzpA+ILnWsV8i/hSIWJduI5UZ2tiqEKOhNiUd5pzLG81PckTuP5qUTOk9gkqlqHK9p0cr89gvsE2YmS/Cj1hPxjohC5TvuYcKaL8Q+KzHGtKDV/Sr25yge4Gy9rfQH/DZ9NYfwD+LZo1J1kXRYHa15jorP4U6zaMlysa6L/AAjlvYZkAVJOAAAAAElFTkSuQmCC"
            alt="Custom Icon"
            style="width: 15px; height: 15px; margin-right: 10px;"
          />
        </template>
      </van-notice-bar>
    </div>

    <div>
      <div style="margin: 10px;">
        <span style="font-size: 16px;">{{$t("index.Highend_area")}}</span>
        <span class="sub">{{$t("index.extreme")}}</span>
      </div>

      <div
        style="
          display: flex;
          width: 100%;
          overflow-y: auto;
          flex-wrap: nowrap;
          padding: 10px;
        "
      >
        <div
          class="gdgride"
          style="margin-right: 5px;"
          v-for="(group, index) in groupedData"
          :key="index"
        >
          <div v-for="item in group" :key="item.id">
            <div
              @click="toDetail(item.id)"
              class="van-image"
              style="
                width: 100px;
                height: 100px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
            <div
              style="
                position: absolute;
                bottom: 10px;
                text-align: center;
                color: rgb(255, 255, 255);
                width: 100%;
                font-size: 12px;
              "
            >
              {{ item.xuanfei_name }}
            </div>
          </div>
        </div>

        <div
          @click="toLogin('/Choose')"
          style="
            width: 23px;
            padding: 20px 5px 10px;
            height: 145px;
            margin-top: 30px;
            background: rgb(249, 249, 249);
            color: rgb(153, 153, 153);
            font-size: 12px;
          "
        >
          {{$t("concubine.ckgdsj")}}
        </div>
      </div>
    </div>

    <div class="online-match-box">
      <div class="online-match-title">
        <span class="online-dot"></span>
        現在 {{ onlineCount }} 人がオンライン中
      </div>

      <div class="OnlineMatching">
        <div
          class="online-scroll"
          :style="{ transform: `translateY(${onlineTranslateY}px)` }"
        >
          <div class="online-row" v-for="(item, index) in displayRollingList" :key="'a' + index">
            <div class="online-avatar-wrap">
              <img :src="item.avatar" class="online-avatar" />
              <span class="online-badge">認証</span>
            </div>
            <div class="online-inline">
              <span class="online-name">{{ item.name }}</span>
              <span class="online-meta">{{ item.age }}歳・{{ item.city }}</span>
              <span class="online-status">ペアーズ恋活サービス</span>
            </div>
            <span class="online-live">LIVE</span>
          </div>

          <div class="online-row" v-for="(item, index) in displayRollingList" :key="'b' + index">
            <div class="online-avatar-wrap">
              <img :src="item.avatar" class="online-avatar" />
              <span class="online-badge">認証</span>
            </div>
            <div class="online-inline">
              <span class="online-name">{{ item.name }}</span>
              <span class="online-meta">{{ item.age }}歳・{{ item.city }}</span>
              <span class="online-status">ペアーズ恋活サービス</span>
            </div>
            <span class="online-live">LIVE</span>
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 10px;">
      <div style="font-size: 16px;">{{$t("index.recommend")}}</div>
      <div>
        <div class="horizontalItem" v-for="item in datalist" :key="item.id" @click="toDetail(item.id)">
          <div class="imgBox">
            <div
              class="van-image"
              style="
                width: 120px;
                height: 120px;
                overflow: hidden;
                border-radius: 8px;
              "
            >
              <img
                :src="item.img_url"
                class="van-image__img"
                style="object-fit: cover;"
              />
            </div>
          </div>

          <div style="width: calc(100% - 140px);">
            <div class="top">
              <div>
                <div class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    style="width: 13px; height: 13px;"
                    class="van-image__img"
                  />
                </div>
                <span>{{$t("index.authentication")}}</span>
              </div>
              <div>
                <div class="van-image" style="width: 13px;">
                  <img
                    src="/img/vip.png"
                    class="van-image__img"
                    style="width: 13px; height: 13px;"
                  />
                </div>
                <span>{{$t("index.video_authentication")}}</span>
              </div>
              <div
                style="
                  width: 70px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ item.xuanfei_name }}
              </div>
            </div>

            <div class="tags">
              <van-tag
                v-for="(tag, index) in item.flagArray"
                :key="index"
                :type="tagTypes[index]"
              >
                {{ tag }}
              </van-tag>
            </div>

            <div style="display: flex; align-items: center;">
              <span style="font-size: 14px; color: rgb(102, 102, 102);">
                {{$t("index.toll")}}：
              </span>
              <van-rate v-model="item.number" color="#ffd21e" size="20px" />
            </div>

            <div
              style="
                color: rgb(153, 153, 153);
                font-size: 12px;
                margin: 5px 0px;
              "
            >
              {{$t("index.height")}}: {{item.hight}}cm {{$t("index.bust")}}：{{ item.bust }} {{$t("index.address")}}： {{$t("index.National")}}：{{$t("index.yes")}}
            </div>

            <div class="yueta">{{$t("index.about")}}</div>
          </div>
        </div>
      </div>
    </div>

    <div style="padding-bottom: 55px;"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      notice: this.$t("index.loading"),
      hasToken: false,
      basicData: [],
      datalist: [],
      groupedData: [],
      banners: [],
      onlineCount: 0,
      onlineTranslateY: 0,
      scrollTimer: null,
      displayRollingList: [],
namePool: [
"佐藤 翠","鈴木 陽葵","高橋 紬","田中 凛","伊藤 茉白","渡辺 さくら","山本 ひなた","中村 陽菜","小林 結菜","加藤 芽依",
"吉田 澪","山田 結愛","佐々木 葵","山口 莉子","松本 ひかり","井上 あかり","木村 結月","林 結衣","斎藤 楓","清水 杏",
"山崎 咲良","池田 美月","橋本 いろは","阿部 すみれ","石川 碧","山下 凪","中島 萌衣","石井 恵","小川 美波","岡田 うみ",
"長谷川 きこ","近藤 あい","前田 遥","藤田 真由美","後藤 加奈子","安倍 香織","村上 愛美","小野 愛理","竹内 茜","森 秋",
"松田 明菜","吉川 朝香","中野 麻美","岡本 明日香","中山 彩花","藤井 彩乃","河野 彩葉","上田 優奈","森田 優花","小島 優希",
"久保 詩","千葉 心愛","藤原 美咲","小山 結","平野 真央","菊池 真琴","新井 遥香","柴田 花音","宮崎 奏","上野 凜花",
"高木 凜音","今井 雫","工藤 栞","大塚 七海","小島 奈々","増田 菜月","遠藤 春菜","酒井 春香","横山 冬美","佐野 雪乃",
"越智 涼花","西村 涼香","武田 怜奈","金子 玲奈","奥村 瑠璃","片山 琉奈","福田 実咲","小野寺 実優","田村 光","竹田 未来",
"多田 望","安藤 爱","杉山 彩","村田 華","谷口 楓花","大野 陽菜乃","菅原 陽菜","小川 結奈","武藤 結心","森本 咲希",
"中川 真央","大西 真奈","田口 唯","高田 唯菜","松村 唯華","小出 乃愛","内田 乃梨","杉本 梨花","服部 莉央","東 莉愛",
"中島 翠","石井 陽葵","小川 紬","岡田 凛","長谷川 茉白","近藤 さくら","前田 ひなた","藤田 陽菜","後藤 結菜","安倍 芽依",
"村上 澪","小野 結愛","竹内 葵","森 莉子","松田 ひかり","吉川 あかり","中野 結月","岡本 結衣","中山 楓","藤井 杏",
"河野 咲良","上田 美月","森田 いろは","小島 すみれ","久保 碧","千葉 凪","藤原 萌衣","小山 恵","平野 美波","菊池 うみ",
"新井 きこ","柴田 あい","宮崎 遥","上野 真由美","高木 加奈子","今井 香織","工藤 愛美","大塚 爱理","小島 茜","増田 秋",
"遠藤 明菜","酒井 朝香","横山 麻美","佐野 明日香","越智 彩花","西村 彩乃","武田 彩葉","金子 優奈","奥村 優花","片山 優希",
"福田 詩","小野寺 心愛","田村 美咲","竹田 結","多田 真央","安藤 真琴","杉山 遥香","村田 花音","谷口 奏","大野 凜花",
"菅原 凜音","小川 雫","武藤 栞","森本 七海","中川 奈々","大西 菜月","田口 春菜","高田 春香","松村 冬美","小出 雪乃",
"内田 涼花","杉本 涼香","服部 怜奈","東 玲奈","福島 瑠璃","渡部 琉奈","安部 実咲","岩崎 実優","野村 光","木下 未来",
"菊地 望","山内 愛","西村 彩","吉村 華","三浦 楓花","福井 陽菜乃","五十嵐 陽菜","富田 結菜","岡崎 結心","三宅 咲希",
"内山 真央","片岡 真奈","奥田 唯","嘉手納 唯菜","亀井 唯華","北村 乃愛","倉田 乃梨","源 梨花","原田 莉央","成瀬 莉愛"
],
     cityPool: [
"新宿区","大阪市","名古屋市","福岡市","札幌市",
"横浜市","京都市","神戸市","仙台市","広島市",
"川崎市","さいたま市","千葉市","北九州市","静岡市",
"新潟市","浜松市","熊本市","岡山市","鹿児島市",
"宇都宮市","松山市","金沢市","長野市","高松市",
"奈良市","和歌山市","大分市","宮崎市","長崎市",
"盛岡市","青森市","秋田市","山形市","福島市",
"水戸市","前橋市","甲府市","津市","岐阜市",
"富山市","福井市","徳島市","高知市","佐賀市",
"山口市","松江市","鳥取市","那覇市","沖縄市",
"渋谷区","堺市","豊田市","久留米市","函館市",
"相模原市","宇治市","姫路市","石巻市","福山市",
"横須賀市","川越市","船橋市","大牟田市","浜松市",
"長岡市","富士市","八代市","倉敷市","鹿屋市",
"小山市","今治市","小松市","松本市","丸亀市",
"橿原市","田辺市","別府市","延岡市","佐世保市",
"一関市","八戸市","横手市","鶴岡市","郡山市",
"つくば市","高崎市","富士吉田市","四日市市","大垣市",
"高岡市","敦賀市","阿南市","南国市","鳥栖市",
"下関市","出雲市","米子市","宜野湾市","うるま市",
"豊島区","枚方市","一宮市","飯塚市","旭川市",
"藤沢市","亀岡市","西宮市","大崎市","呉市",
"大和市","所沢市","市川市","春日市","沼津市",
"上越市","焼津市","天草市","津山市","薩摩川内市",
"足利市","西条市","白山市","上田市","坂出市",
"生駒市","紀の川市","中津市","日向市","諫早市",
"花巻市","弘前市","由利本荘市","酒田市","いわき市",
"日立市","伊勢崎市","笛吹市","伊勢市","各務原市",
"射水市","越前市","鳴門市","四万十市","唐津市",
"宇部市","浜田市","倉吉市","浦添市","名護市",
"足立区","東大阪市","岡崎市","筑紫野市","帯広市",
"平塚市","城陽市","尼崎市","塩竈市","東広島市",
"茅ヶ崎市","越谷市","柏市","糸島市","磐田市",
"三条市","藤枝市","玉名市","総社市","霧島市",
"栃木市","伊予市","加賀市","飯田市","さぬき市",
"大和郡山市","海南市","佐伯市","日南市","大村市",
"北上市","十和田市","大仙市","米沢市","会津若松市",
"ひたちなか市","太田市","甲斐市","鈴鹿市","多治見市",
"魚津市","坂井市","吉野川市","香南市","伊万里市",
"防府市","益田市","境港市","糸満市","豊見城市"
    ],
      avatarPool: Array.from({ length: 60 }, (_, i) => `/img/avatar/avatar${i + 1}.png`),
      bannerSwiperOption: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        speed: 800,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        observer: true,
        observeParents: true,
        coverflowEffect: {
          rotate: 50,
          stretch: 10,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      tagTypes: ["primary", "success", "danger", "warning"]
    };
  },
  methods: {
    getBannerUrl(url) {
      if (!url) return "";
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      return "https://" + url;
    },
    getNoticeText(data) {
      if (!data || !data.notice) {
        return this.$t("index.loading");
      }
      return data.notice;
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        this.basicData = res.data;
        this.getNotice(this.basicData);
        this.getBanner(this.basicData);
      });
    },
    getHotLottery() {
      this.$http({
        method: "get",
        url: "lottery_hot",
      }).then((res) => {
        console.log(res, 11);
      });
    },
    getBanner(data) {
      this.banners = Array.isArray(data.banners) ? data.banners : [];
    },
    toLogin(str) {
      this.$router.push({ path: str });
    },
    getNotice(data) {
      this.notice = this.getNoticeText(data);
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    checkToken() {
      const token = localStorage.getItem("token");
      this.hasToken = !!token;
    },
    getxuanfeilist() {
      this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { id: 1, page: 1 },
      }).then((res) => {
        const lanng = localStorage.getItem("lang");
        this.datalist = res.data;

        this.datalist.forEach(item => {
          const parts = item.flag.split("|");
          lanng == "zh"
            ? item.flag = parts[0]
            : lanng == "en"
            ? item.flag = parts[1]
            : lanng == "ja"
            ? item.flag = parts[2]
            : item.flag = parts[3];

          item.flagArray = item.flag.split("，");
        });

        const chunkSize = 2;
        this.groupedData = this.datalist.reduce((acc, item, index) => {
          if (index % chunkSize === 0) acc.push([]);
          acc[Math.floor(index / chunkSize)].push(item);
          return acc;
        }, []);
      });
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    shuffleArray(arr) {
      const newArr = [...arr];
      for (let i = newArr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
      }
      return newArr;
    },

setRandomOnlineCount() {
  // 1. 如果没有初始值，在 5000 到 200000 之间生成一个随机起始数
  if (!this.onlineCount) {
    this.onlineCount = this.getRandomInt(5000, 200000);
    return;
  }

  // 2. 产生 500 到 1000 之间的波动
  // 使用 Math.random() 决定正负方向，确保数字有涨有跌
  const isIncrease = Math.random() > 0.5;
  const change = this.getRandomInt(500, 1000);
  
  if (isIncrease) {
    this.onlineCount += change;
  } else {
    this.onlineCount -= change;
  }

  // 3. 锁定边界：最小 5000，最大 200000
  if (this.onlineCount < 5000) this.onlineCount = 5000;
  if (this.onlineCount > 200000) this.onlineCount = 200000;
},

    buildRollingList() {
      const names = this.shuffleArray(this.namePool).slice(0, 2);
      const cities = this.shuffleArray(this.cityPool);
      const avatars = this.shuffleArray(this.avatarPool);

      this.displayRollingList = names.map((name, index) => ({
        name,
        city: cities[index],
        age: this.getRandomInt(25, 45),
        avatar: avatars[index]
      }));
    },
    startOnlineMatchingAnimation() {
      this.$nextTick(() => {
        const rowHeight = Math.round(window.innerWidth * 0.145);

        if (this.scrollTimer) {
          clearInterval(this.scrollTimer);
        }

        let currentIndex = 0;

        this.scrollTimer = setInterval(() => {
          currentIndex += 1;
          this.onlineTranslateY = -(currentIndex * rowHeight);

          if (currentIndex >= this.displayRollingList.length) {
            setTimeout(() => {
              this.onlineTranslateY = 0;
              currentIndex = 0;
              this.buildRollingList();
              this.setRandomOnlineCount();
            }, 500);
          }
        }, 2400);
      });
    }
  },
  mounted() {
    this.buildRollingList();
    this.setRandomOnlineCount();
    this.startOnlineMatchingAnimation();
  },
  beforeDestroy() {
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
    }
  },
  created() {
    this.checkToken();
    this.getBasicConfig();
    this.getxuanfeilist();
    this.getHotLottery();
  },
};
</script>

<style lang="less" scoped>
.header {
  height: 13vw;
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}
.header_content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin: 0 40px;
  color: #fff;
  .img {
    height: 80px;
    display: flex;
    align-items: center;

    img {
      height: 100%;
      width: auto;
      display: block;
      object-fit: contain;
    }
  }
}
.notice-swiper {
  height: 11vw;
  font-size: 4vw;
  border-radius: 7vw;
}
.sub {
  background: rgb(63, 58, 91);
  padding: 8px;
  color: rgb(235, 202, 175);
  font-size: 24px;
  border-radius: 16px 0;
  margin-left: 4px;
}
.gdgride {
  padding-right: 40px;
}
.gdgride div {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
}
.van-image {
  position: relative;
  display: inline-block;
}

.online-match-box {
  width: 96%;
  margin: 3vw auto 5vw;
  padding: 2.8vw 2.6vw 3.2vw;
  border-radius: 4vw;
  box-sizing: border-box;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(255,255,255,0.18), transparent 34%),
    radial-gradient(circle at bottom right, rgba(255,255,255,0.12), transparent 30%),
    linear-gradient(135deg, #ff5f89 0%, #ff7b9f 48%, #ff91ab 100%);
  box-shadow: 0 2vw 4vw rgba(232, 86, 130, 0.16);
}

.online-match-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.4vw;
  color: #fff27d;
  text-align: center;
  padding: 0.2vw 0 2.4vw;
  font-size: 4.1vw;
  font-weight: 700;
  letter-spacing: 0.2vw;
  text-shadow: 0 0.2vw 0.6vw rgba(0,0,0,0.08);
}

.online-dot {
  width: 1.8vw;
  height: 1.8vw;
  border-radius: 50%;
  background: #7cff9d;
  box-shadow: 0 0 1.8vw rgba(124,255,157,0.9);
  flex-shrink: 0;
}

.OnlineMatching {
  height: 29vw;
  overflow: hidden;
}

.online-scroll {
  transition: transform 0.55s ease-in-out;
}

.online-row {
  height: 14.5vw;
  display: flex;
  align-items: center;
  padding: 2vw 2.2vw;
  margin-bottom: 1vw;
  border-radius: 3.2vw;
  box-sizing: border-box;
  background: linear-gradient(90deg, rgba(255,255,255,0.18), rgba(255,255,255,0.10));
  border: 1px solid rgba(255,255,255,0.18);
  backdrop-filter: blur(2px);
}

.online-avatar-wrap {
  position: relative;
  flex-shrink: 0;
  margin-right: 2.2vw;
}

.online-avatar {
  width: 9vw;
  height: 9vw;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
  border: 0.5vw solid rgba(255,255,255,0.95);
  box-shadow: 0 0.8vw 1.8vw rgba(0,0,0,0.12);
}

.online-badge {
  position: absolute;
  right: -0.8vw;
  bottom: -0.4vw;
  padding: 0.2vw 1vw;
  border-radius: 2vw;
  background: linear-gradient(90deg, #7a4cff, #c93cff);
  color: #fff;
  font-size: 2vw;
  line-height: 1.5;
  border: 1px solid rgba(255,255,255,0.75);
}

.online-inline {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 1.6vw;
  white-space: nowrap;
  overflow: hidden;
}

.online-name {
  color: #fff;
  font-size: 3.8vw;
  font-weight: 700;
  flex-shrink: 0;
}

.online-meta {
  color: rgba(255,255,255,0.96);
  font-size: 3.15vw;
  flex-shrink: 0;
}

.online-status {
  min-width: 0;
  color: #fff;
  font-size: 3.15vw;
  opacity: 0.98;
  overflow: hidden;
  text-overflow: ellipsis;
}

.online-live {
  margin-left: 1.8vw;
  padding: 0.5vw 1.6vw;
  border-radius: 999px;
  background: rgba(255,255,255,0.18);
  color: #fff;
  font-size: 2.6vw;
  font-weight: 700;
  letter-spacing: 0.08vw;
  flex-shrink: 0;
  border: 1px solid rgba(255,255,255,0.22);
}

.horizontalItem {
  display: flex;
  border-bottom: 2px solid #eee;
  padding: 40px 0 4vw;
}
.horizontalItem .imgBox {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  margin-right: 40px;
}
.top {
  display: flex;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div :nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .top div:first-child,
.horizontalItem .top div:nth-child(2) {
  background: linear-gradient(180deg, #e7caaf, #fff7ed);
  color: #a4826b;
  font-weight: 600;
  font-size: 3vw;
  padding: 3px;
  margin-right: 10px;
}
.horizontalItem .tags {
  display: flex;
  margin: 10px 0 10px;
  flex-wrap: wrap;
}
.horizontalItem .tags .van-tag {
  padding: 15px;
  font-size: 3vw;
  margin: 0 10px 10px 0;
  border-radius: 16px;
}
.horizontalItem .yueta {
  background: linear-gradient(90deg, #df35ad, #4f1db5);
  color: #fff;
  border-radius: 16px;
  padding: 20px 0;
  text-align: center;
  font-size: 3vw;
}
</style>